import { Label } from "@/components/ui/label";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue
} from "@/components/ui/select";
import { NamePrefixTypes } from "@/domain/core";
import { cn, components } from "@/utilities/tailwind-utils";

interface NamePrefixSelectProps {
  value: string;
  onChange: (value: string) => void;
  required?: boolean;
  disabled?: boolean;
  className?: string;
}

export function NamePrefixSelect({
  value,
  onChange,
  required,
  disabled,
  className
}: NamePrefixSelectProps) {
  return (
    <div className={cn("flex flex-col gap-1.5", className)}>
      <Label htmlFor="namePrefix">Prefix</Label>
      <Select
        value={value}
        onValueChange={onChange}
        required={required}
        disabled={disabled}
      >
        <SelectTrigger
          className={cn(components.selectTriggerFormField, "w-25")}
        >
          <SelectValue placeholder="Select name prefix" />
        </SelectTrigger>
        <SelectContent>
          {Object.values(NamePrefixTypes).map((prefix, idx) => (
            <SelectItem key={prefix + idx} value={prefix}>
              {prefix}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
}
